import { Link } from "react-router-dom";
import { site } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-950 text-background-200">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-lg font-extrabold text-primary-950">
                51
              </span>
              <span className="text-lg font-extrabold text-background-50">{site.brand}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              {site.intro}
            </p>
            <div className="mt-5 flex items-center gap-2">
              {site.socials.map((s) => (
                <span
                  key={s.name}
                  title={s.name}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-lg text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-950"
                >
                  <i className={s.icon}></i>
                </span>
              ))}
            </div>
          </div>

          {site.footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold uppercase tracking-wide text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.items.map((item) => (
                  <li key={item.path + item.label}>
                    <Link
                      to={item.path}
                      className="text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wide text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <span className="break-all">{site.contact.email}</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-line mt-0.5 text-accent-400"></i>
                <span>{site.contact.phone}</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line mt-0.5 text-accent-400"></i>
                <span>{site.contact.address}</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line mt-0.5 text-accent-400"></i>
                <span>{site.contact.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap gap-2 border-t border-primary-900 pt-6">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/category/${c.id}`}
              className="rounded-full bg-primary-900 px-3 py-1 text-xs text-background-300 transition-colors hover:bg-primary-800 hover:text-background-50"
            >
              {c.name}资讯
            </Link>
          ))}
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex w-full flex-col gap-2 px-4 py-5 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© {year} {site.brand} · 保留所有权利</p>
          <p>本站当前为前端演示版本，赛事与排行数据均为示例，实时数据后续接入。</p>
        </div>
      </div>
    </footer>
  );
}